import LegalPage from "../components/LegalPage";
import { CONTACT } from "../content/legal";

export default function Contact() {
  return <LegalPage title="Contact & Support" source={CONTACT} />;
}
